import {
  await1uwe8zvsjq69o as await_0,
  Key_instance2oomvptbmjvj0 as Key_instance,
  awaitOnce3bs0u39jtmrli as awaitOnce,
} from '../context/DependencyChangeListener.mjs';
import {
  $3l5vvh8yg0ier as $,
  orPromise1iucc2to2udt2 as orPromise,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/coroutinesInteropJs.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../context/CalculationContext.mjs';
import { toList3jhuyej2anx2q as toList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { remember2m0mx1b5ra75q as remember } from '../core/Remember.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
import {
  Companion_getInstance3bjjjd8igr9ok as Companion_getInstance,
  lens2x0usmj7eco4 as lens,
  lens2po2j99uxhjgr as lens_0,
  MutableReactive2qdhhyljdknhy as MutableReactive,
  Reactive1jy75v4li6ldv as Reactive,
  beginUse146s8dwmfk72s as beginUse,
  Listenable3m4zqvjcbvczy as Listenable,
} from '../core/coreInterfaces.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *modify(_this__u8e3s4, action, $completion) {
  yield* _this__u8e3s4.set_revjhg_k$(yield* $(action(yield* await_0(_this__u8e3s4, $completion), $completion), $completion), $completion);
  return Unit_instance;
}
function *modify_0(_this__u8e3s4, action, $completion) {
  _this__u8e3s4.set_value_v1vabv_k$(yield* $(action(_this__u8e3s4.get_value_j01efc_k$(), $completion), $completion));
  return Unit_instance;
}
function withWrite(_this__u8e3s4, action) {
  return new (withWrite$1())(_this__u8e3s4, action);
}
function use(_this__u8e3s4, resourceUse) {
  var tmp0_safe_receiver = _this__u8e3s4.get_coroutineContext_115oqo_k$().get_y2st91_k$(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    use_0(tmp0_safe_receiver, resourceUse);
    return Unit_instance;
  }
  // Inline function 'kotlin.also' call
  var this_0 = resourceUse.beginUse_omrbby_k$();
  onRemove(_this__u8e3s4, this_0);
}
function plus(_this__u8e3s4, other) {
  return new (plus$1())(_this__u8e3s4, other);
}
function invokeAllSafeMutable(_this__u8e3s4) {
  return invokeAllSafe(toList(_this__u8e3s4));
}
function flatten(_this__u8e3s4) {
  var tmp = remember(VOID, VOID, VOID, VOID, ($this$remember) => $this$remember.invoke_r7m7el_k$($this$remember.invoke_r7m7el_k$(_this__u8e3s4)));
  return withWrite(tmp, flatten$slambda(_this__u8e3s4));
}
function use_0(_this__u8e3s4, resourceUse) {
  if (_this__u8e3s4.existingDependency_tkmz95_k$(resourceUse) == null) {
    _this__u8e3s4.registerDependency_23xa5k_k$(resourceUse, resourceUse.beginUse_omrbby_k$());
  }
}
function invokeAllSafe(_this__u8e3s4) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = _this__u8e3s4.iterator_jk1svi_k$();
  while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
    var element = _iterator__ex2g4s.next_20eer_k$();
    $l$block: {
      try {
        element();
      } catch ($p) {
        if ($p instanceof Exception()) {
          var e = $p;
          if (e instanceof CancellationException()) {
            break $l$block;
          }
          Companion_getInstance().reportException_1(e);
        } else {
          throw $p;
        }
      }
    }
  }
  return Unit_instance;
}
var withWrite$1Class;
function withWrite$1() {
  if (withWrite$1Class === VOID) {
    class $_0 {
      constructor($this_withWrite, $action) {
        this.$this_withWrite_1 = $this_withWrite;
        this.$action_1 = $action;
        this.$$delegate_0__1 = $this_withWrite;
      }
      *set_revjhg_k$(value, $completion) {
        yield* $(this.$action_1(this.$this_withWrite_1, value, $completion), $completion);
        return Unit_instance;
      }
      get_state_wc71uu_k$() {
        return this.$$delegate_0__1.get_state_wc71uu_k$();
      }
      addListener_6y9mct_k$(listener) {
        return this.$$delegate_0__1.addListener_6y9mct_k$(listener);
      }
      beginUse_omrbby_k$() {
        return this.$$delegate_0__1.beginUse_omrbby_k$();
      }
    }
    protoOf($_0).lens_drj4fu_k$ = lens;
    protoOf($_0).lens_u4wb4z_k$ = lens_0;
    initMetadataForClass($_0, VOID, VOID, VOID, [MutableReactive(), Reactive()], [1]);
    withWrite$1Class = $_0;
  }
  return withWrite$1Class;
}
var plus$1Class;
function plus$1() {
  if (plus$1Class === VOID) {
    class $ {
      constructor($this_plus, $other) {
        this.$this_plus_1 = $this_plus;
        this.$other_1 = $other;
      }
      addListener_6y9mct_k$(listener) {
        var a = this.$this_plus_1.addListener_6y9mct_k$(listener);
        var b = this.$other_1.addListener_6y9mct_k$(listener);
        return () => {
          a();
          b();
          return Unit_instance;
        };
      }
    }
    protoOf($).beginUse_omrbby_k$ = beginUse;
    initMetadataForClass($, VOID, VOID, VOID, [Listenable()]);
    plus$1Class = $;
  }
  return plus$1Class;
}
function flatten$slambda($this_flatten) {
  return constructCallableReference(($this$withWrite, it, $completion) => orPromise($completion, function *($completion) {
    yield* (yield* awaitOnce($this_flatten, $completion)).set_revjhg_k$(it, $completion);
    return Unit_instance;
  }), 2);
}
//region block: exports
export {
  flatten as flattenml92kmikh8fo,
  invokeAllSafeMutable as invokeAllSafeMutable13vuy5ase10ma,
  plus as plus39grgnv43k79,
  use as use25wcggkyjf1ad,
  withWrite as withWritedlio9p0oewet,
  modify as modify3w2ijgzr8982m,
  modify_0 as modify1cw751ztekmcu,
};
//endregion

//# sourceMappingURL=helpers.mjs.map
